"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _bluebird = require("bluebird");

var _bluebird2 = _interopRequireDefault(_bluebird);

var _SettingsHandler2 = require("./SettingsHandler");

var _SettingsHandler3 = _interopRequireDefault(_SettingsHandler2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * A wrapper for a SettingsHandler that performs local echo on
 * changes to settings. This wrapper will use the underlying
 * handler as much as possible to ensure values are not stale.
 */
/*
Copyright 2017 Travis Ralston

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/

var LocalEchoWrapper = function (_SettingsHandler) {
    (0, _inherits3.default)(LocalEchoWrapper, _SettingsHandler);

    /**
     * Creates a new local echo wrapper
     * @param {SettingsHandler} handler The handler to wrap
     */
    function LocalEchoWrapper(handler) {
        (0, _classCallCheck3.default)(this, LocalEchoWrapper);

        var _this = (0, _possibleConstructorReturn3.default)(this, (LocalEchoWrapper.__proto__ || (0, _getPrototypeOf2.default)(LocalEchoWrapper)).call(this));

        _this._handler = handler;
        _this._cache = {
            // settingName: { roomId: value }
        };
        return _this;
    }

    (0, _createClass3.default)(LocalEchoWrapper, [{
        key: "getValue",
        value: function getValue(settingName, roomId) {
            var cacheRoomId = roomId ? roomId : "UNDEFINED"; // avoid weird keys
            var bySetting = this._cache[settingName];
            if (bySetting && bySetting.hasOwnProperty(cacheRoomId)) {
                return bySetting[roomId];
            }

            return this._handler.getValue(settingName, roomId);
        }
    }, {
        key: "setValue",
        value: function setValue(settingName, roomId, newValue) {
            if (!this._cache[settingName]) this._cache[settingName] = {};
            var bySetting = this._cache[settingName];

            var cacheRoomId = roomId ? roomId : "UNDEFINED"; // avoid weird keys
            bySetting[cacheRoomId] = newValue;

            var handlerPromise = this._handler.setValue(settingName, roomId, newValue);
            return _bluebird2.default.resolve(handlerPromise).finally(function () {
                delete bySetting[cacheRoomId];
            });
        }
    }, {
        key: "canSetValue",
        value: function canSetValue(settingName, roomId) {
            return this._handler.canSetValue(settingName, roomId);
        }
    }, {
        key: "isSupported",
        value: function isSupported() {
            return this._handler.isSupported();
        }
    }]);
    return LocalEchoWrapper;
}(_SettingsHandler3.default);

exports.default = LocalEchoWrapper;
module.exports = exports["default"];
//# sourceMappingURL=LocalEchoWrapper.js.map